import { Card, Stack, TextField } from "@mui/material";
import SearchIcon from "assets/icons1/search_icon.svg";
import CustomTable from "global/components/CustomTable/CustomTable";
import { useEffect, useState } from "react";
import { GroupHeaders } from "./Constants";
import strings from "global/constants/StringConstants";
import { debounceEventHandler, handleErrorMessage } from "helpers/methods";
import { cloneDeep } from "lodash";
import {
  fetchFilterTags,
  fetchFilterTagsCount,
} from "screens/Tags/TagsService";

interface CustomProps {
  selectedAudienceIds: number[];
  setSelectedAudienceIds: Function;
}

const TagSelection = (props: CustomProps) => {
  const [count, setCount] = useState<number>(0);
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState({
    search: "",
    page: 1,
    rowsPerPage: 5,
  });

  useEffect(() => {
    retrieveGroups();
  }, [filters]);

  const retrieveGroups = async () => {
    try {
      setIsLoading(true);
      const [counts, groups] = await Promise.all([
        fetchFilterTagsCount(filters.search),
        fetchFilterTags(filters.page, filters.rowsPerPage, filters.search),
      ]);
      setCount(counts);
      setTags(convertToTableFormat(groups));
      setCount(counts);
      setTags(convertToTableFormat(groups));
      setIsLoading(false);
    } catch (error: any) {
      handleErrorMessage(error);
      setIsLoading(false);
    }
  };

  const handleSearchParams = (event: any) => {
    setFilters({
      ...filters,
      page: 1,
      search: event.target.value.trim(),
    });
  };

  const onSelectOne = (id: number) => {
    const selectedIds = cloneDeep(props.selectedAudienceIds);
    selectedIds.push(id);
    props.setSelectedAudienceIds(selectedIds);
  };

  const onDeselectOne = (id: number) => {
    props.setSelectedAudienceIds(
      props.selectedAudienceIds.filter((select: number) => select !== id)
    );
  };

  const convertToTableFormat = (groups: any) => {
    return groups.map((group: any) => {
      return {
        rowId: group.id,
        name: group.name,
        contacts: group.recipientCount,
      };
    });
  };

  return (
    <Stack spacing={2}>
      <TextField
        id="groups_search_box"
        placeholder="Search..."
        variant="outlined"
        fullWidth
        onChange={debounceEventHandler(
          handleSearchParams,
          strings.SEARCH_TIME_OUT
        )}
        InputProps={{
          startAdornment: (
            <Stack mr={1}>
              <img src={SearchIcon} width="30px" height="20px" />
            </Stack>
          ),
        }}
      />
      <Card sx={{ borderColor: "#e5e7eb !important" }}>
        <CustomTable
          isLoading={isLoading}
          count={count}
          rows={tags}
          headers={GroupHeaders}
          showCheckbox
          page={filters.page ?? 1}
          rowsPerPage={filters.rowsPerPage ?? 10}
          onRowsPerPageChange={(number: number) => {
            setFilters({ ...filters, rowsPerPage: number });
          }}
          onSelectOne={onSelectOne}
          onDeselectOne={onDeselectOne}
          onSelectAll={() => {
            const allIds = tags.map((row: any) => row.rowId);
            props.setSelectedAudienceIds((prev: any) =>
              Array.from(new Set(prev.concat(allIds)))
            );
          }}
          onDeselectAll={() => {
            const allIds = tags.map((row: any) => row.rowId);
            props.setSelectedAudienceIds((prev: any) =>
              prev.filter((id: any) => !allIds.includes(id))
            );
          }}
          selected={props.selectedAudienceIds}
          onPageChange={(event: any, newPage: number) => {
            setFilters({ ...filters, page: newPage });
          }}
          rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
        />
      </Card>
    </Stack>
  );
};

export default TagSelection;
